<template>
  <div class="vch-myaccount-logout">
    <div
      data-sc-field-key="586012721D3541B2A716A9E1ADE25E48"
      class="logout-btn"
    >
      <input
        @click="logout"
        :value="logoutLabel"
        type="submit"
        name="fxb.8df31dde-d521-41f7-8c44-ef6c7d80fa70.903286b4-3a35-4647-b858-2882067a9908"
        data-sc-field-key="55422D8BA4B84B8182ADA5E1965C73E0"
        class="logout-button logout button -primary --fit-content"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'vch-myaccount-logout',
  props: {
    logoutApi: {
      type: String,
      required: true,
    },
    redirectUrl: {
      type: String,
      required: true,
    },
    logoutLabel: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      logoutlabel: this.logoutLabel,
    };
  },
  methods: {
    logout() {
      fetch(this.logoutApi, {
        method: 'GET',
      })
        .then(async (response) => {
          if (response.ok) {
            window.location.href = this.redirectUrl;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss" src="./myaccount-logout.scss"></style>
